$(document).ready(function (ready) {

    if ( $('.text_block-link a:not(.disabled)').length ) {
        $(document).on('click', '.text_block-link a:not(.disabled)', function (evt) {
            if ( $('.text_block-link a:not(.disabled)').attr('href') === 'https://artistpush.io/music-branding/' ) {

                eS('sendEvent', 'ProductPage', {
                    'ProductPage': {
                        'productKey': 'landing2',
                        'price': '2.00 $',
                        'isInStock': 1,
                    }});

            } else if (  $('.text_block-link a:not(.disabled)').attr('href') === 'https://artistpush.io/' ) {

                eS('sendEvent', 'ProductPage', {
                    'ProductPage': {
                        'productKey': 'landing1',
                        'price': '1.00 $',
                        'isInStock': 1,
                    }});

            }
        })
    }


})
let productRecommendationPopup = document.querySelector('.js-product-recommendation-popup');
if(productRecommendationPopup){
    let productRecommendationPopupOverflow = productRecommendationPopup.querySelector('.product-recommendation-popup-overflow');
    if(productRecommendationPopupOverflow){
        productRecommendationPopupOverflow.addEventListener('click',function (){
            productRecommendationPopup.classList.remove('open');
        });
    }
}